module.exports = __webpack_public_path__ + "static/media/budget.b184b105.png";